import Button from '@components/v2/ui/Button/Button';
import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import LangEnum from '../../../../../lang/LangEnum';
import { useTranslation } from '../../../../translation/TranslationContext';
import { RecoveryEmailSentContent, ResendButtonConfig } from '../recoverPasswordPanel.types';

interface RecoveryEmailSentProps {
  content: RecoveryEmailSentContent;
  resendButton: ResendButtonConfig;
  loginPath: string;
}

const RecoveryEmailSent = ({ content, resendButton, loginPath }: RecoveryEmailSentProps) => {
  const { translate } = useTranslation();

  return (
    <Stack sx={{ width: '100%', alignItems: 'center', gap: 4, textAlign: 'center' }}>
      <Stack sx={{ alignItems: 'center', gap: 1.5 }}>
        <Typography variant="subtitle2">{translate(content.title)}</Typography>
        <Typography variant="body2" color="text.secondary">
          <FormattedMessage
            id={content.message}
            values={{
              email: content.email,
              b: (chunks: ReactNode) => (
                <Typography component="span" variant="body2" color="text.primary">
                  {chunks}
                </Typography>
              ),
            }}
          />
        </Typography>
      </Stack>
      <Stack sx={{ width: '100%', gap: 1 }}>
        <Button
          variant="text"
          color="primary"
          size="large"
          fullWidth
          disabled={resendButton.disabled}
          loading={resendButton.loading}
          onClick={resendButton.onClick}
        >
          {resendButton.label}
        </Button>
        <Button variant="text" color="secondary" size="large" fullWidth to={loginPath}>
          {translate(LangEnum.GLOBAL_GO_BACK_TO_LOGIN)}
        </Button>
      </Stack>
    </Stack>
  );
};

export default RecoveryEmailSent;
